// ── STAYS: RV, Tent, Cabins ──────────────────────────────────────────────────
const { Ico: I2, Photo: P2, Btn: B2, Eyebrow: E2, Stat: S2, Reveal: R2, InteriorHero } = window.BCKit;

const FeatureRow = ({ idx, title, body, tone, src, side }) => {
  const img = <P2 tone={tone} src={src} label={title} h={300} r={18} />;
  const txt = (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
        <span className="serif" style={{ fontSize: 15, fontWeight: 700, color: "var(--amber)" }}>{idx}</span>
        <span style={{ height: 1, width: 40, background: "var(--rule-2)" }} />
      </div>
      <h3 className="display" style={{ fontSize: "clamp(26px,3vw,34px)" }}>{title}</h3>
      <p className="lede" style={{ marginTop: 14, fontSize: 16.5 }}>{body}</p>
    </div>
  );
  return (
    <R2>
      <div className="grid2" style={{ alignItems: "center", gridTemplateColumns: side === "left" ? "1.1fr 1fr" : "1fr 1.1fr" }}>
        {side === "left" ? <>{img}{txt}</> : <>{txt}{img}</>}
      </div>
    </R2>
  );
};

// One price set (nightly + any enabled weekly/monthly/seasonal rates). Used once
// per card normally, or twice side-by-side for back-in vs pull-through RV sites.
const RateBlock = ({ label, price, weekly, weeklyPrice, monthly, monthlyPrice, seasonal, seasonalPrice, size = 48 }) => (
  <div>
    {label && <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".07em", textTransform: "uppercase", color: "var(--muted)", marginBottom: 4 }}>{label}</div>}
    <div style={{ display: "flex", alignItems: "baseline", gap: 7, margin: label ? "0 0 8px" : "12px 0 8px" }}>
      <span className="serif" style={{ fontSize: size, fontWeight: 800, color: "var(--green)", lineHeight: 1 }}>${price}</span>
      <span style={{ color: "var(--muted)", fontSize: 14 }}>/ night</span>
    </div>
    {((weekly && weeklyPrice) || (monthly && monthlyPrice) || (seasonal && seasonalPrice)) ? (
      <div style={{ display: "flex", flexDirection: "column", gap: 3, margin: "0 0 16px", fontSize: 14, color: "var(--muted)" }}>
        {weekly && !!weeklyPrice && <span><strong style={{ color: "var(--green)" }}>${weeklyPrice}</strong> / week</span>}
        {monthly && !!monthlyPrice && <span><strong style={{ color: "var(--green)" }}>${monthlyPrice}</strong> / month</span>}
        {seasonal && !!seasonalPrice && <span><strong style={{ color: "var(--green)" }}>${seasonalPrice}</strong> / season</span>}
      </div>
    ) : <div style={{ marginBottom: 12 }} />}
  </div>
);

const PriceCard = ({ tier, link, data, go }) => {
  const { t, price, feats, popular, weekly, weeklyPrice, monthly, monthlyPrice, seasonal, seasonalPrice, pull } = tier;
  // Show the back-in vs pull-through split only once a pull-through price is set;
  // otherwise render the single price exactly as before.
  const hasPull = pull && Number(pull.price) > 0;
  return (
  <div className="card" style={{ padding: "30px 28px", position: "relative", height: "100%", overflow: "visible",
    border: popular ? "2px solid var(--amber)" : "1px solid rgba(40,33,20,.06)",
    boxShadow: popular ? "0 16px 40px rgba(194,132,29,.2)" : "var(--shadow-sm)" }}>
    {popular && <span style={{ position: "absolute", top: -13, left: "50%", transform: "translateX(-50%)", background: "var(--amber)", color: "#fff", fontSize: 11.5, fontWeight: 600, letterSpacing: ".06em", textTransform: "uppercase", padding: "5px 14px", borderRadius: 999, whiteSpace: "nowrap" }}>★ Most popular</span>}
    <h3 className="serif" style={{ fontSize: 21, fontWeight: 700 }}>{t}</h3>
    {hasPull ? (
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, margin: "14px 0 0" }}>
        <RateBlock label="Back-in" size={30} price={price} weekly={weekly} weeklyPrice={weeklyPrice} monthly={monthly} monthlyPrice={monthlyPrice} seasonal={seasonal} seasonalPrice={seasonalPrice} />
        <RateBlock label="Pull-through" size={30} price={pull.price} weekly={pull.weekly} weeklyPrice={pull.weeklyPrice} monthly={pull.monthly} monthlyPrice={pull.monthlyPrice} seasonal={pull.seasonal} seasonalPrice={pull.seasonalPrice} />
      </div>
    ) : (
      <RateBlock price={price} weekly={weekly} weeklyPrice={weeklyPrice} monthly={monthly} monthlyPrice={monthlyPrice} seasonal={seasonal} seasonalPrice={seasonalPrice} />
    )}
    <div style={{ height: 1, background: "var(--rule)", margin: "8px 0 20px" }} />
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      {feats.map(f => (
        <div key={f} style={{ display: "flex", gap: 11, alignItems: "center" }}>
          <span style={{ width: 21, height: 21, borderRadius: "50%", background: "var(--amber-soft)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <I2.check style={{ width: 12, height: 12, color: "var(--green)" }} />
          </span>
          <span style={{ fontSize: 14.5 }}>{f}</span>
        </div>
      ))}
    </div>
    <div style={{ marginTop: 24 }}>
      <B2 kind={popular ? "primary" : "outline"} block icon={<I2.phone />} {...window.BCStore.resolveCtaProps(link, { data, go }, { action: "phone", value: "" })}>Call to reserve</B2>
    </div>
  </div>
  );
};

const BottomCTA = ({ title, sub, primaryLink, secondaryLink, go }) => {
  const [data] = window.BCStore.useStore();
  const { phone } = data.contact;
  return (
  <section style={{ background: "var(--green-deep)", color: "#fff", position: "relative", overflow: "hidden" }}>
    <div style={{ position: "absolute", top: -100, right: -60, width: 380, height: 380, borderRadius: "50%", background: "radial-gradient(circle,rgba(194,132,29,.3),transparent 68%)" }} />
    <div className="wrap section" style={{ position: "relative", textAlign: "center" }}>
      <R2>
        <h2 className="display" style={{ fontSize: "clamp(32px,4.4vw,46px)", color: "#fff" }}>{title}</h2>
        <p style={{ fontSize: 17, color: "rgba(255,255,255,.72)", marginTop: 12 }}>{sub}</p>
        <div style={{ display: "flex", gap: 14, justifyContent: "center", marginTop: 26, flexWrap: "wrap" }}>
          <B2 kind="amber" size="lg" icon={<I2.phone />} {...window.BCStore.resolveCtaProps(primaryLink, { data, go }, { action: "phone", value: "" })}>{phone}</B2>
          <B2 kind="white" size="lg" iconRight={<I2.arrow />} {...window.BCStore.resolveCtaProps(secondaryLink, { data, go }, { action: "email", value: "" })}>Email us</B2>
        </div>
      </R2>
    </div>
  </section>
  );
};

const AmenityGrid = ({ items }) => (
  <div className="grid4">
    {items.map((a, i) => (
      <R2 delay={(i % 4) * 60} key={a}>
        <div className="card" style={{ padding: "16px 18px", display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--green)", flexShrink: 0 }} />
          <span style={{ fontSize: 14.5, fontWeight: 500 }}>{a}</span>
        </div>
      </R2>
    ))}
  </div>
);

// ── RV ───────────────────────────────────────────────────────────────────────
const RVSites = ({ go }) => {
  const [data] = window.BCStore.useStore();
  const rv = data.pages.rv;
  return (
    <main>
      <InteriorHero eyebrow={rv.hero.eyebrow} title={rv.hero.title} sub={rv.hero.sub} stats={rv.hero.stats} photo={rv.hero.photo} />
      <section className="section">
        <div className="wrap">
          <R2><E2>{rv.pricing.eyebrow}</E2><h2 className="display" style={{ fontSize: "clamp(30px,4vw,42px)", marginTop: 10, marginBottom: 34 }}>{rv.pricing.title}</h2></R2>
          <div className="grid3">
            {rv.pricing.tiers.map((tier, i) => (
              <R2 delay={i * 90} key={tier.id}><PriceCard tier={tier} link={rv.reserveLink} data={data} go={go} /></R2>
            ))}
          </div>
        </div>
      </section>
      <section className="section" style={{ background: "var(--paper-2)", paddingTop: 56 }}>
        <div className="wrap">
          <R2><E2>{rv.amenities.eyebrow}</E2><h2 className="display" style={{ fontSize: "clamp(26px,3.4vw,36px)", marginTop: 10, marginBottom: 28 }}>{rv.amenities.title}</h2></R2>
          <AmenityGrid items={rv.amenities.items} />
        </div>
      </section>
      <BottomCTA title={rv.cta.title} sub={rv.cta.sub} primaryLink={rv.cta.primaryLink} secondaryLink={rv.cta.secondaryLink} go={go} />
    </main>
  );
};

// ── TENT ─────────────────────────────────────────────────────────────────────
const TentSites = ({ go }) => {
  const [data] = window.BCStore.useStore();
  const t = data.pages.tent;
  return (
    <main>
      <InteriorHero eyebrow={t.hero.eyebrow} title={t.hero.title} sub={t.hero.sub} photo={t.hero.photo} />
      <section className="section">
        <div className="wrap">
          <div className="grid2" style={{ alignItems: "center", gridTemplateColumns: "1.15fr 1fr" }}>
            <R2><P2 tone={t.intro.tone} src={t.intro.src} label={t.intro.photoLabel} h={380} r={20} /></R2>
            <R2 delay={120}>
              <E2>{t.intro.eyebrow}</E2>
              <h2 className="display" style={{ fontSize: "clamp(28px,3.6vw,38px)", marginTop: 10 }}>{t.intro.title}</h2>
              <p className="lede" style={{ marginTop: 16 }}>{t.intro.body}</p>
              <div style={{ display: "flex", alignItems: "baseline", gap: 8, margin: "24px 0" }}>
                <span className="serif" style={{ fontSize: 44, fontWeight: 800, color: "var(--green)" }}>${t.intro.price}</span>
                <span style={{ color: "var(--muted)" }}>per night</span>
              </div>
              <B2 kind="primary" icon={<I2.phone />} {...window.BCStore.resolveCtaProps(t.reserveLink, { data, go }, { action: "phone", value: "" })}>Call to reserve</B2>
            </R2>
          </div>
        </div>
      </section>
      <section className="section" style={{ background: "var(--paper-2)", display: "flex", flexDirection: "column", gap: 56 }}>
        <div className="wrap" style={{ display: "flex", flexDirection: "column", gap: 56 }}>
          {t.features.map((f, i) => (
            <FeatureRow key={f.id} idx={String(i + 1).padStart(2, "0")} side={i % 2 === 0 ? "left" : "right"} tone={f.tone} src={f.src} title={f.title} body={f.body} />
          ))}
        </div>
      </section>
      <BottomCTA title={t.cta.title} sub={t.cta.sub} primaryLink={t.cta.primaryLink} secondaryLink={t.cta.secondaryLink} go={go} />
    </main>
  );
};

// ── CABINS ───────────────────────────────────────────────────────────────────
const CabinGallery = ({ idx, unit, alt, link, data, go }) => {
  const ph = unit.photos || [];
  return (
  <section className="section" style={alt ? { background: "var(--paper-2)" } : undefined}>
    <div className="wrap">
      <R2>
        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", flexWrap: "wrap", gap: 18, marginBottom: 26 }}>
          <div style={{ maxWidth: 560 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
              <span className="serif" style={{ fontSize: 15, fontWeight: 700, color: "var(--amber)" }}>{idx}</span>
              <span style={{ height: 1, width: 40, background: "var(--rule-2)" }} />
              <E2>{unit.eyebrow}</E2>
            </div>
            <h2 className="display" style={{ fontSize: "clamp(28px,3.6vw,40px)" }}>{unit.name}</h2>
            <p className="lede" style={{ marginTop: 12, fontSize: 16.5 }}>{unit.blurb}</p>
            {!!Number(unit.price) && (
              <div style={{ display: "flex", alignItems: "baseline", gap: 7, marginTop: 16 }}>
                <span className="serif" style={{ fontSize: 32, fontWeight: 800, color: "var(--green)", lineHeight: 1 }}>${unit.price}</span>
                <span style={{ color: "var(--muted)", fontSize: 14 }}>/ night</span>
              </div>
            )}
          </div>
          <B2 kind="outline" icon={<I2.phone />} {...window.BCStore.resolveCtaProps(link, { data, go }, { action: "phone", value: "" })}>Call to reserve</B2>
        </div>
      </R2>
      <R2 delay={100}>
        <div style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr", gap: 16, height: 400 }}>
          <P2 tone={ph[0]?.tone} src={ph[0]?.src} label={ph[0]?.label} r={20} />
          <div style={{ display: "grid", gridTemplateRows: "1fr 1fr", gap: 16 }}>
            <P2 tone={ph[1]?.tone} src={ph[1]?.src} label={ph[1]?.label} r={20} />
            <P2 tone={ph[2]?.tone} src={ph[2]?.src} label={ph[2]?.label} r={20} />
          </div>
        </div>
      </R2>
      <R2 delay={140}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "40px 0 22px" }}>
          <span className="serif" style={{ fontSize: 13, fontWeight: 600, letterSpacing: ".14em", textTransform: "uppercase", color: "var(--muted)" }}>Inside the {unit.name}</span>
          <span style={{ flex: 1, height: 1, background: "var(--rule)" }} />
        </div>
        {unit.mode === "tags"
          ? <div style={{ display: "flex", flexWrap: "wrap", gap: 9 }}>
              {(unit.tags || []).map(x => <span key={x} className="chip chip--static">{x}</span>)}
            </div>
          : <div className="grid3">
              {(unit.specs || []).map(([t, d], i) => (
                <div className="card" style={{ padding: "20px 22px" }} key={i}>
                  <div className="serif" style={{ fontSize: 18, fontWeight: 700 }}>{t}</div>
                  <div style={{ color: "var(--muted)", fontSize: 14, marginTop: 3 }}>{d}</div>
                </div>
              ))}
            </div>}
      </R2>
    </div>
  </section>
  );
};

const BringProvideCol = ({ data, provided, delay }) => (
  <R2 delay={delay}>
    <E2>{data.eyebrow}</E2>
    <h3 className="display" style={{ fontSize: 26, marginTop: 10, marginBottom: 18 }}>{data.title}</h3>
    {(data.items || []).map(x => (
      <div key={x} style={{ display: "flex", gap: 11, alignItems: "center", padding: "8px 0", fontSize: 15.5, color: provided ? "var(--green)" : undefined, borderBottom: "1px solid var(--rule)" }}>
        {provided
          ? <I2.check style={{ width: 16, height: 16 }} />
          : <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--rule-2)" }} />}
        {x}
      </div>
    ))}
  </R2>
);

const Cabins = ({ go }) => {
  const [data] = window.BCStore.useStore();
  const c = data.pages.cabins;
  return (
  <main>
    <InteriorHero eyebrow={c.hero.eyebrow} title={c.hero.title} sub={c.hero.sub} stats={c.hero.stats} photo={c.hero.photo} />
    {c.units.map((u, i) => (
      <CabinGallery key={u.id} idx={String(i + 1).padStart(2, "0")} unit={u} alt={i % 2 === 1} link={c.reserveLink} data={data} go={go} />
    ))}
    <section className="section" style={{ background: "var(--paper-2)" }}>
      <div className="wrap grid2">
        <BringProvideCol data={c.bring} />
        <BringProvideCol data={c.provide} provided delay={120} />
      </div>
    </section>
    <BottomCTA title={c.cta.title} sub={c.cta.sub} primaryLink={c.cta.primaryLink} secondaryLink={c.cta.secondaryLink} go={go} />
  </main>
  );
};

window.BCStays = { RVSites, TentSites, Cabins };
